import * as React from "react";
import { Link } from "react-router-dom";
import { rxRoute } from "../../helpers/formatting";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class ActionTile extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.ActionTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { title, clickAction, containerClass, iconClass, path } = this.props;
        return (
            <div className={containerClass} onClick={() => { if (clickAction) clickAction(); }}>
                <Link to={{ pathname: rxRoute(path) }} >
                    <div className="img-button text-center">
                        <div className="btn-icon">
                            <span className={iconClass} />
                        </div>
                        <div className="btn-label">
                            {title}
                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}